<template>
  <v-row justify="center">
    <v-col class="text-center" cols="12" sm="8" md="4">
      <a href="http://tqm.com.ua/ua" target="_blank">
        <img
          src="../../../../public/logo.png"
          width="207"
          height="71"
          class="my-5"
        />
      </a>
      <v-card class="elevation-12 mt-5">
        <v-card-text class="pr-4">
          <v-form v-model="valid">
            <h1 class="headline font-weight-medium pt-1 pb-3">
              Вхід до кабінету
            </h1>
            <CustomTextField
              v-model="username"
              prepend-icon="person"
              label="Логін"
              :rules="usernameRules"
              required
              :hide-details="false"
              data-test="login"
              @keyup.enter="login"
            />
            <PasswordField
              v-model="password"
              prepend-icon="lock"
              data-test="password"
              @keyup.enter="login"
            />
          </v-form>
          <v-alert v-model="showError" type="error" dismissible>
            {{ error }}
          </v-alert>
          <v-btn
            :disabled="!valid"
            :loading="processedByServer"
            color="primary"
            class="my-2 login-btn"
            @click="login"
          >
            Увійти
          </v-btn>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import auth from "@/auth.js";
import { mapActions } from "vuex";
import * as usersApi from "@/backend/usersApi.js";
import * as loginApi from "@/backend/loginApi.js";
import Vue from "vue";

export default {
  data: () => ({
    username: "",
    password: "",
    usernameRules: [
      (v) => !!v || "Логін не може бути пустим",
      (v) => v.length >= 3 || "Логін повинен містити не менше 3-х символів",
    ],
    passwordRules: [(v) => !!v || "Пароль не може бути менше пустим"],
    valid: false,
    processedByServer: false,
    error: "",
    showError: false,
  }),
  methods: {
    ...mapActions("user", ["setUser"]),
    async login() {
      if (this.valid) {
        this.processedByServer = true;

        try {
          const token = await loginApi.login(this.username, this.password);

          if (token) {
            auth.login(token);

            const user = await usersApi.getCurrentUser();
            this.setUser(user);

            auth.setUser(user);

            if (this.$toLink) {
              this.$router.push({ path: this.$toLink });
              Vue.prototype.$toLink = "";
            } else {
              this.$router.push({ path: "/" });
            }
          } else {
            this.showErrorMessage();
          }
        } catch (error) {
          return error;
        } finally {
          this.processedByServer = false;
        }
      }
    },
    showErrorMessage() {
      this.processedByServer = false;
      this.error = "Помилка авторизації";
      this.showError = true;
    },
  },
};
</script>
